var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',{attrs:{"length":5,"prev-icon":_vm.icons.mdiMenuLeft,"next-icon":_vm.icons.mdiMenuRight},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})}
var staticRenderFns = []

export { render, staticRenderFns }